if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
           
              window.location = window.routes.cart_url;  
             
            
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          setTimeout(function() {
          
          var var_id = document.querySelector('.product-variant-id').getAttribute('value');
          if(var_id){
            var max_qty = parseInt(document.querySelector('.additional-variants[data-variant-id="'+var_id+'"]').getAttribute('data-max'));
             fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                var items = cart.items;
                var item_have = false;
                for(var i=0;i<items.length;i++){
                  if(items[i].id == var_id){
                    var cart_qty = items[i].quantity;
                   
                    if(max_qty == cart_qty){
                      document.querySelector('[name="quantity"]').setAttribute('data-max', max_qty);
                      document.querySelector('[name="quantity"]').setAttribute('max', 0);
                      document.querySelector('[name="quantity"]').value = 0;
                      document.querySelector('.quantity__button[name="plus"]').classList.add('disabled');
                      var qty_rule = document.querySelector('.quantity__rules-cart');
                      if(qty_rule){
                        qty_rule.classList.remove('hidden');
                        qty_rule.querySelector('.quantity__rules-cart .quantity-cart').innerHTML = cart_qty;
                      }
                      var qtymax_limit = document.querySelector('.qtyMaxLimitMsg');
                      if(qtymax_limit){
                        console.log('hiii')
                        // qtymax_limit.classList.remove('hidden');
                        qtymax_limit.style.display = "block";
                      }
                    }else{
                      var minus_qty = max_qty - cart_qty;
                      document.querySelector('[name="quantity"]').setAttribute('data-max', max_qty);
                      document.querySelector('[name="quantity"]').setAttribute('max', minus_qty);
                      var qty_rule = document.querySelector('.quantity__rules-cart');
                      if(qty_rule){
                        qty_rule.classList.remove('hidden');
                        qty_rule.querySelector('.quantity__rules-cart .quantity-cart').innerHTML = cart_qty;
                      }
                      var qtymax_limit = document.querySelector('.qtyMaxLimitMsg');
                      if(qtymax_limit){
                        // qtymax_limit.classList.add('hidden');
                        qtymax_limit.style.display = "none";
                      }
                    }
                  }
                }
             })
            .catch(error => {
              console.error('Error fetching the cart data:', error);
            });
          }
          }, 500);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

let buyItNow = document.querySelector(".buy-it-now");
buyItNow.addEventListener("click" , function(){
let variantId = buyItNow.closest(".product-form").querySelector(".product-variant-id").value;
console.log(variantId);
let addData = {
    'id':variantId,
    'quantity':1
};
fetch('/cart/add.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
    },
    method: 'POST'
}).then(function(response) {
    return response.json();
}).then(function(json) {
    /* we have JSON */
    console.log(json);
  
    window.location.href ='/cart';
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });
});
